export default __webpack_public_path__ + "static/media/illust_home_wave_dark.b5f3396c.svg";